"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = require("prop-types");
const intl_1 = require("@kyruus/intl");
const loaders_and_spinners_1 = require("@kyruus/loaders-and-spinners");
const styles_1 = require("./styles");
const messages_1 = __importDefault(require("../../../lib/messages"));
/**
 * NextLoader component
 *
 * @description NextLoader component to show loader with message
 *
 * @param {object} props
 * @param {string} props['data-testid'] test id to be applied on the container
 * @param {boolean} props.showMessage condition to hide or show message
 *
 * @returns
 */
const NextLoader = (_a) => {
    var { showMessage } = _a, props = __rest(_a, ["showMessage"]);
    return (react_1.default.createElement(styles_1.LoadingContainer, Object.assign({}, props),
        react_1.default.createElement(loaders_and_spinners_1.FadingLinesSpinner, null),
        showMessage && (react_1.default.createElement(styles_1.Msg, null,
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.nextloader))))));
};
NextLoader.propTypes = {
    'data-testid': prop_types_1.string,
    showMessage: prop_types_1.bool
};
NextLoader.defaultProps = {
    'data-testid': 'nextLoader',
    showMessage: true
};
exports.default = NextLoader;
//# sourceMappingURL=NextLoader.js.map